import { useCallback, useState } from 'react';
import useCrud from 'hooks/useCrud';
import { useAddVoucherToMap } from 'hooks/business/conversation';
import { voucherList, VoucherListParams } from 'services/api/conversation';

function useVoucher() {
  const addVoucherToMap = useAddVoucherToMap();
  const [lastSyncTime, setLastSyncTime] = useState<string | undefined>();

  const { setList, ...others } = useCrud({
    readList: useCallback(
      (params: VoucherListParams) => {
        return voucherList(params).then((response) => {
          const voucherList = response.data.data || [];
          addVoucherToMap(voucherList, `${params.internal_store_id}`);
          setLastSyncTime(response.data.lastSyncTime);
          return voucherList;
        });
      },
      [addVoucherToMap],
    ),
  });

  const deleteVoucher = useCallback(
    (voucher: Conversation.Voucher.Vo) => {
      setList((list) => {
        if (!list) {
          return list;
        }

        return list.filter(
          ({ internalVoucherId }) => internalVoucherId !== voucher.internalVoucherId,
        );
      });
    },
    [setList],
  );

  const updateVoucher = useCallback(
    (voucher: Conversation.Voucher.Vo) => {
      setList((list) => {
        if (!list) {
          return list;
        }

        return list.map((cur) => {
          if (cur.internalVoucherId === voucher.internalVoucherId) {
            return voucher;
          }

          return cur;
        });
      });
    },
    [setList],
  );

  return {
    setList,
    ...others,
    deleteVoucher,
    updateVoucher,
    lastSyncTime,
  };
}

export default useVoucher;
